import  { VueGallerySlideshowNew }  from '../components/vdp/vue-gallery-slide-show-new.vue';
Vue.component('vue-gallery-slide-show-new', VueGallerySlideshowNew);
//console.log(['aqui',VueGallerySlideshowNew]);
window.VueGallerySlideshowNew = VueGallerySlideshowNew;